import { wagmiConfig as config, } from "@wagmiconfig";
import { amountToBigInt, } from "../helpers";
import { calculateMint, } from "@bracket/contractor-next/brktETH";
import { getTokenDefinition, } from "@bracket/chainography";
import type { GetQuoterProps, GetQuoteResult, } from "./getQuote";



/**
 * Calculates the amount of tokens to mint based on the input amount and token
 * @summary for native swaps (ie. WETH or ETH) we need to convert the amount to WSTETH first, get that mint calculation alongisde the conversion rate, and return the value as WSTETH * conversion rate.
 * @param {Object} params - The parameters for calculating mint amount
 * @param {AmountString} params.amount - The input amount as a string
 * @param {TokenDefinition} params.token - The token definition containing decimals and address
 * @returns {Promise<bigint>} The calculated mint amount in the token's native decimals
 * @throws {Error} If the contract call fails or returns an invalid value
 */
export const calculateMintAmount = async ({
	amount,
	tokenIn,
}:GetQuoterProps): Promise<GetQuoteResult> => {

	const bAmount = amountToBigInt(amount, tokenIn);
	const tok = getTokenDefinition(tokenIn);

	if(bAmount === BigInt(0)) {
		return {
			token: tok,
			amount: BigInt(0),
			native: false,
		}
	}

	try {

		const result = await calculateMint({
			token: tok,
			amount: bAmount,
			config,
		});

		if(typeof result === "bigint") {

			return {
				token: tok,
				amount: result,
				native: false,
			};

		}

		throw new Error("SwapStore::calculateMintAmount failed to receive a valid value");
	}
	catch (error) {

		throw new Error(`SwapStore::calculateMintAmount failed to receive a valid value: ${error instanceof Error ? error.message : "unknown error"}`);
	}
};
